<template>
  <div>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.replyTo"
        :validator="vs.form.replyTo"
        label="Reply-to e-mail"
      />
    </v-flex>
    <v-flex v-if="isPerformanceSelectingEnabled" class="pb-16">
      <v-select
        v-model="selectedEventId"
        :items="performanceDates"
        label="Performance*"
        item-text="from"
        item-value="id"
        box
      />
    </v-flex>
    <v-flex class="pb-16">
      <select-field
        v-model="form.recipients"
        :validator="vs.form.recipients"
        :items="recipients"
        :disabled="recipients.length === 1"
        label="Recipients*"
      />
    </v-flex>
    <v-flex class="pb-16">
      <v-combobox
        v-if="form.recipients === 'Specific categories'"
        v-model="form.categories"
        :items="categories"
        item-value="id"
        item-text="name"
        label="Categories"
        multiple
        small-chips
        deletable-chips
        @focus="form.attendees = []"
      />
      <v-combobox
        v-if="form.recipients === 'Specific attendees'"
        v-model="form.attendees"
        :items="attendees"
        item-value="id"
        item-text="name"
        label="Attendees*"
        multiple
        small-chips
        deletable-chips
        @focus="form.categories = []"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.subject" :validator="vs.form.subject" label="Subject" />
    </v-flex>
    <v-flex class="pb-16">
      <text-editor-field
        v-model.trim="form.content"
        :validator="vs.form.content"
        label="Content"
        height="390"
      />
    </v-flex>
  </div>
</template>

<script>
import { GET_EVENT_CATEGORIES, GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import moment from 'moment/moment'
import { GET_ALLOWED_ATTENDEES_BY_EVENT_ID } from '@/graphql/accreditation.graphql'

export default {
  name: 'create-theater-event-email-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    eventTemplateId: {
      default: null,
      type: String,
    },
    organizationSlug: String,
    initiallySelectedEventId: String,
    isPerformanceSelectingEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: [],
      recipients: ['All attendees', 'Specific categories', 'Specific attendees'],
      categories: [],
      attendees: [],
      initAttendees: [],
      initCategories: [],
      performanceDates: [],
      selectedEventId: null,
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val.type === 'Automated' && this.recipients.length > 1) {
          if (this.recipients.indexOf('Specific attendees') >= 0) {
            this.recipients.splice(this.recipients.indexOf('Specific attendees'), 1)
          }
        }
        this.$emit('values', val)
      },
      deep: true,
    },
    selectedEventId: {
      async handler(val) {
        this.recipients = ['All attendees', 'Specific categories', 'Specific attendees']
        const {
          data: {
            getEventCategories: { categories },
          },
        } = await this.$apollo.query({
          query: GET_EVENT_CATEGORIES,
          variables: { id: val },
        })

        this.categories = categories
        if (this.categories.length) {
          this.categories.map(categorie => {
            if (this.initCategories.includes(categorie.id.toString())) {
              this.form.categories.push(categorie)
            }
          })
        } else {
          if (this.recipients.indexOf('Specific attendees') >= 0) {
            this.recipients.splice(this.recipients.indexOf('Specific categories'), 1)
          }
        }

        const {
          data: { getAllowedAttendeesByEventId: attendees },
        } = await this.$apollo.query({
          query: GET_ALLOWED_ATTENDEES_BY_EVENT_ID,
          variables: {
            eventId: val,
          },
        })

        this.attendees = attendees.map(function (attendee) {
          return {
            name:
              (attendee.fields['First name'] || attendee.fields['Ime'] || '') +
              ' ' +
              (attendee.fields['Last name'] || attendee.fields['Prezime'] || ''),
            ...attendee,
          }
        })
        if (this.initAttendees.length) {
          this.attendees.map(attendee => {
            if (this.initAttendees.includes(attendee.id.toString())) {
              this.form.attendees.push(attendee)
            }
          })
        }
        if (!this.attendees.length && this.recipients.length > 1) {
          if (this.recipients.indexOf('Specific attendees') >= 0) {
            this.recipients.splice(this.recipients.indexOf('Specific attendees'), 1)
          }
        }
      },
    },
  },
  mounted() {
    const { attendees, categories, ...rest } = this.initialValues
    this.form = rest
    this.form.categories = []
    this.form.attendees = []
    this.initAttendees = attendees || []
    this.initCategories = categories || []
  },
  methods: {
    categoriesChanged(categories) {
      this.form.categories = categories.map(categorie => categorie.id)
      this.form.attendees = []
    },
    attendeesChanged(attendees) {
      this.form.attendees = attendees.map(attendee => attendee.id)
      this.form.categories = []
    },
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = [
          ...getEventsByEventTemplateId.map(p => {
            return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
          }),
        ]
        this.selectedEventId = this.initiallySelectedEventId || getEventsByEventTemplateId[0].id
      },
    },
  },
}
</script>

<style scoped></style>
